import { DentalProcedure } from '../store/types/prescription';
import { GET_TREATMENT_PLAN } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { TreatmentPlan } from './getTreatmentPlans';

export interface Response {
    success: boolean;
    treatmentPlan: TreatmentPlan;
    receipts?: Receipt[];
    treatmentProcedures?: DentalProcedure[];
    latestAId?: string;
    latestAIdWithWorkdone?: string;
    latestPxIdWithWorkdone?: string;
    error?: string;
}

export interface Receipt {
    receipt_id: number;
    payment_id: string;
    receipt_type: string;
    updated_at: string;
    payment_status: string;
    receipt_number: number;
    receipt_url: string;
    receipt_amount: number;
    additional_discount_value: number;
    additional_discount_type: string;
    additional_discount_amount: number;
    net_amount: number;
    name: string;
    mobile: string;
    amount_due: number;
    created_at: string;
    remarks: string;
    receipt_payment: ReceiptPayment[];
    receipt_sku: ReceiptSku[];
}

export interface ReceiptPayment {
    paymode: string;
    amount: number;
}

export interface ReceiptSku {
    quantity: number;
    amount: number;
    discount_value: number;
    discount_type: string;
    discount_amount: number;
    net_amount: number;
    sku_item: SkuItem;
}

export interface SkuItem {
    service_name: string;
    service_id: number;
    price: number;
}

export default (planId: string, aId: string): Promise<Response> => {
    return fetchWithRefresh(GET_TREATMENT_PLAN(planId, aId)).then((res) => res.json());
};
